import React from "react"

import { ProjectPageProjectSidebar } from "./ProjectPageProjectSidebar"
import {
  UseProjectPageProjectSidebarModelArgs,
  useProjectPageProjectSidebarModel
} from "./hooks/useProjectPageProjectSidebarModel"

export const ProjectPageProjectSidebarConnector = React.memo(
  (props: UseProjectPageProjectSidebarModelArgs) => (
    <ProjectPageProjectSidebar
      id="project-page-project-sidebar"
      {...useProjectPageProjectSidebarModel(props)}
    />
  )
)
